import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import { useGlobalSearch } from '@/components/misc/GlobalSearch/hooks/useGlobalSearch'
import { faSearch } from '@/lib/fontAwesomePro/regular'

const SearchButton: React.FC = () => {
  const globalSearch = useGlobalSearch()

  return (
    <FontAwesomeIcon
      onClick={globalSearch.show}
      className="cursor-pointer p-2"
      icon={faSearch}
      style={{ fontSize: '20px' }}
    />
  )
}

export default SearchButton
